import ValidService from "@/service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  ten: undefined, // required, minLength: 1 - Tên đại lý
  ten_day_du: undefined,
  loai: "doanh_nghiep", // required, enum(ca_nhan, doanh_nghiep) - Loại đại lý
  logo_id: undefined,
  // optional - Các trường thông tin nếu đại lý thuộc loại doanh nghiệp
  doanh_nghiep: {
    nguoi_dai_dien: {
      ten: "",
      can_cuoc: "",
      dia_chi: {
        quoc_gia_id: "",
        tinh_id: "",
        huyen_id: "",
        xa_id: "",
        dia_chi: "",
      },
      dien_thoai: "", // required, pattern: /^84\d{9}$|^(?!(0|84))\d{7,}$/ - Số điện thoại
      email: null, // optional, pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/ - Địa chỉ email
    },
    ma_so_thue: "", // required - Mã số thuế
    dang_ky_kinh_doanh: "", // optional - Mã số đăng ký kinh doanh
    // required - Thông tin địa chỉ
    dia_chi: {
      quoc_gia_id: "", // optional, ref: quoc_gia - Mã quốc gia
      tinh_id: "", // optional, ref: province - Mã tỉnh
      huyen_id: "", // optional, ref: district - Mã huyện
      xa_id: "", // optional, ref: commune - Mã xã
      dia_chi: "", // optional - Địa chỉ chi tiết
    },
    van_phong_giao_dich: [],
    dien_thoai: "", // required, pattern: /^84\d{9}$|^(?!(0|84))\d{7,}$/ - Số điện thoại
    email: null, // optional, pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/ - Địa chỉ email
    // optional - Thông tin về người đại diện của đại lý
    nguoi_lien_he: {
      ten: "", // required, minLength: 1 - Họ tên
      can_cuoc: "", // required - Số căn cước công dân
      dia_chi: {
        quoc_gia_id: "", // optional, ref: quoc_gia - Mã quốc gia
        tinh_id: "", // optional, ref: province - Mã tỉnh
        huyen_id: "", // optional, ref: district - Mã huyện
        xa_id: "", // optional, ref: commune - Mã xã
        dia_chi: "", // optional - Địa chỉ chi tiết
      },
      dien_thoai: "", // required, pattern: /^84\d{9}$|^(?!(0|84))\d{7,}$/ - Số điện thoại
      email: null, // optional, pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/ - Địa chỉ email
    },
  },
  // optional - Các trường thông tin cá nhân
  ca_nhan: {
    ten: undefined, // required, minLength: 1 - Họ tên
    can_cuoc: undefined, // required - Số căn cước công dân
    // required - Thông tin địa chỉ
    dia_chi: {
      quoc_gia_id: undefined, // optional, ref: quoc_gia - Mã quốc gia
      tinh_id: undefined, // optional, ref: province - Mã tỉnh
      huyen_id: undefined, // optional, ref: district - Mã huyện
      xa_id: undefined, // optional, ref: commune - Mã xã
      dia_chi: undefined, // optional - Địa chỉ chi tiết
    },
    dien_thoai: undefined, // required, pattern: /^84\d{9}$|^(?!(0|84))\d{7,}$/ - Số điện thoại
    email: null, // optional, pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/ - Địa chỉ email
  },
  thong_tin_thanh_toan: {
    ngan_hang_id: undefined,
    so_tai_khoan: undefined, // required - Số tài khoản
    ten_chu_tai_khoan: undefined, // required - Tên chủ tài khoản
    ten_ngan_hang: undefined, // required - Tên ngân hàng
    chi_nhanh: undefined, // optional - Tên chi nhánh ngân hàng
  },
  trang_thai: undefined, // required, enum(cho_duyet, hoat_dong, ngung_hop_tac, huy) - Trạng thái của đại lý: Chờ duyệt, hoạt động, ngừng hợp tác, hủy
  chu_ky_thanh_toan: undefined, // optional, enum(theo_don, theo_thang) - Chu kỳ thanh toán theo đơn hay theo tháng
  loai_dong_tien: undefined, // optional, enum(ve_viettoc, ve_dai_ly) - Dòng tiền về Việt Tộc hay đại lý
  hop_dong_file_ids: [], // optional - Các file liên quan đến hợp đồng sau khi đã phê duyệt
  nguoi_quan_ly_ids: [], // optional - Danh sách các user có thể quản lý thông tin đại lý này
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  tai_khoan: undefined,
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Mã người cập nhật cuối
  // optional - Các cấu hình đại lý
  cau_hinh: {
    // optional - Đăng ký dòng họ
    dang_ky_dong_ho: {
      dung_thu: false, // optional - Cho phép đăng ký dùng thử
      so_ngay_dung_thu: undefined, // optional - Số ngày dùng thử
    },
    tao_dai_ly_tinh: undefined, // optional - Có được tạo tự động đại lý tỉnh
    tao_voucher: undefined, // optional - Có được tạo voucher
  },
  voucher_tags: [],
};

model.capDaiLy = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
];
model.chuKyThanhToan = [
  { value: "theo_don", label: "Theo đơn" },
  { value: "theo_thang", label: "Theo tháng" },
];
model.loaiDongTien = [
  { value: "ve_dai_ly", label: "Về Đại lý" },
  { value: "ve_viettoc", label: "Về Việt Tộc" },
];
model.typeAgent = [
  { value: "doanh_nghiep", label: "Doanh nghiệp" },
  { value: "ca_nhan", label: "Cá nhân" },
];
model.statusAgent = [
  { value: "cho_duyet", label: "Chờ duyệt" },
  { value: "hoat_dong", label: "Hoạt động" },
  { value: "ngung_hop_tac", label: "Ngừng hợp tác" },
  { value: "huy", label: "Hủy" },
];
model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  fields:
    "id,ten,ma,loai,tai_khoan,dia_chi,dien_thoai,doanh_nghiep,ca_nhan,thong_tin_thanh_toan,trang_thai,hop_dong_file_ids,nguoi_quan_ly_ids,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",

  dataSearch: {
    value: {
      ten: "",
      trang_thai: "",
      ma: ''
    },
    operator: {
      ten: ":regex_i:",
      trang_thai: "",
      ma: ':regex_i:'
    },
  },
};

export default model;
